import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";

export function BlogAuthorForm() {
  return (
    <>
      <TextInput autoFocus name="name" label="Name" className="col-span-6" />
      <TextInput name="role" label="Role" className="col-span-6" />
      <TextAreaInput name="bio" label="Bio" className="col-span-12" />
    </>
  );
}
